import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"
import { cn } from "../../lib/utils"

export interface SliderProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  showRange?: boolean
}

const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, SliderProps>(
  ({ className, value, defaultValue, min = 0, max = 100, step = 1, showRange = true, ...props }, ref) => {
    const currentValue = (value ?? defaultValue ?? [min]) as number[]
    const percent = ((currentValue[0] - min) / (max - min)) * 100

    return (
      <div className={cn("w-full space-y-2", className)}>
        <SliderPrimitive.Root
          ref={ref}
          className="relative flex w-full touch-none select-none items-center"
          value={value}
          defaultValue={defaultValue}
          min={min}
          max={max}
          step={step}
          {...props}
        >
          <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full border border-black bg-[#EAECF0]">
            <SliderPrimitive.Range
              className="absolute h-full rounded-full border border-black bg-[#0D41E1]"
              style={{ width: `${percent}%` }}
            />
          </SliderPrimitive.Track>
          <SliderPrimitive.Thumb className="block h-6 w-6 rounded-full border-2 border-[#0D41E1] bg-white shadow-[0px_4px_8px_-2px_rgba(16,24,40,0.1),0px_2px_4px_-2px_rgba(16,24,40,0.06)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#0D41E1]" />
        </SliderPrimitive.Root>
        {showRange && (
          <div className="flex items-center justify-between text-[12px] text-[#98A2B3]">
            <span>${min.toLocaleString()}</span>
            <span>${max.toLocaleString()}+</span>
          </div>
        )}
      </div>
    )
  }
)
Slider.displayName = "Slider"

export { Slider }
